import { getUserUnrestrictedAccessSummaryQuery } from '#generated/graphql/getUserUnrestrictedAccessSummaryQuery.graphql';
import { useLazyLoadQuery } from 'react-relay';
import { graphql } from 'relay-runtime';
import { useToken } from '../../../../Flow/ConsentContextProvider';

export function useUserUnrestrictedAccessSummary() {
  const { userId } = useToken();
  const response = useLazyLoadQuery<getUserUnrestrictedAccessSummaryQuery>(
    query,
    {},
    { fetchKey: userId },
  );
  return response.trello?.userUnrestrictedAccessSummary ?? null;
}

const query = graphql`
  query getUserUnrestrictedAccessSummaryQuery {
    trello {
      userUnrestrictedAccessSummary @optIn(to: "TrelloUserUnrestrictedAccessSummary") {
        topWorkspaces {
          id
          displayName
          displayBoardCount
        }
        totalWorkspaces
      }
    }
  }
`;
